export default {
  method_unavailable: 'Această metodă de plată nu este disponibilă momentan. Alege alta.',
  payment_option_unavailable: 'Această opțiune de plată nu este disponibilă momentan. Alege altă metodă de plată.',
  online_payment_unavailable: 'Plata online nu este disponibilă momentan. Încearcă din nou peste puțin timp.',
  retry_payment_methods: 'Încearcă din nou',
  payment_not_ready: 'Plata ta este încă în curs de pregătire. Încearcă din nou peste câteva momente.',
  wallet_total_changed: 'Totalul pentru această metodă de plată s-a schimbat. Verifică-l și atinge din nou butonul.',
  wallet_tap_above: 'Atinge butonul {{method}} de mai sus pentru a plăti sau alege altă metodă de plată.',
  wallet_pay_above: 'Folosește butonul {{method}} de mai sus',
  element_incomplete: 'Completează datele de plată pentru a continua.',
  element_incomplete_card: 'Verifică datele cardului și încearcă din nou.',
  element_incomplete_bank: 'Alege banca pentru a continua.',
  element_incomplete_sepa_debit: 'Verifică IBAN-ul și datele titularului contului pentru a continua.',
};
